import * as React from 'react';
import { useState } from 'react';
import { Advisor } from '../Types/Advisor';
import { AdvisorCard, ConsultantCardCtas } from '../Consultants/ConsultantCard';

const consultantsPath = '/consultants';
const consultantsEssayReviewPath = '/consultants/essay-review';

export const AdvisorCardCta = (advisor: Advisor) => {
  function buttonsToDisplay() {
    let buttons = []
    if (advisor.validForAdvisingSessions) {
      buttons.push(ConsultantCardCtas.BookSession);
    }
    if (advisor.validForEssayReview) {
      buttons.push(ConsultantCardCtas.EssayReview);
    }
    buttons.push(ConsultantCardCtas.ViewProfile);

    return buttons
  }

  return (
    <AdvisorCard
      advisor={advisor}
      targetBlank={false}
      showBorder={true}
      ctas={buttonsToDisplay()}
      removeH100={true}
    />
  )
}

export const FindAnAdvisorCta = () => {
  return (
    <div className="card rounded-1 border-0 shadow bg-yellow-50">
      <div className="card-body p-3 d-flex flex-column align-items-stretch">
        <div className="text-center fs-lg fw-semibold text-dark">Have questions about the admissions process?</div>
        <div className="text-center mt-1">Start working with a Sundial advisor today!</div>
        <div className="d-flex justify-content-center mt-3">
          <div className="avatar avatar-xl z-5">
            <img className="avatar-img rounded-circle" src='/img/advisors/veronica.png' />
          </div>
          <div className="avatar avatar-xl ms-n3 z-4">
            <img className="avatar-img rounded-circle" src='/img/advisors/elias.png' />
          </div>
          <div className="avatar avatar-xl ms-n3 z-3">
            <img className="avatar-img rounded-circle" src='/img/advisors/priya.png' />
          </div>
          <div className="avatar avatar-xl ms-n3 z-2">
            <img className="avatar-img rounded-circle" src='/img/advisors/daniel.png' />
          </div>
          <div className="avatar avatar-xl ms-n3 z-1">
            <img className="avatar-img rounded-circle" src='/img/advisors/amy.png' />
          </div>
        </div>
        <div className="mt-4 text-center">
          <a className="btn btn-primary w-100 fw-bold fs-lg mb-1" href={consultantsPath}>Find an advisor</a>
          {/* <div className="text-muted fs-sm">and get personalized help</div> */}
        </div>
      </div>
    </div>
  )
}

export const EssayHelpCta = () => {
  const copyVariants = [
    {
      title: "Struggling with your college essays?",
      subtitle: "Get personalized feedback from experienced admissions advisors — fast.",
      buttonText: "Get essay help"
    },
    {
      title: "Not sure if your essay is working?",
      subtitle: "Our expert reviewers can help you strengthen your story and stand out.",
      buttonText: "Submit your essay"
    },
    {
      title: "Your story matters — let’s make it shine",
      subtitle: "Our advisors have reviewed thousands of essays and can help you today.",
      buttonText: "Get help with your essay"
    },
    {
      title: "Get your essay reviewed today",
      subtitle: "Fast, expert feedback — no fluff.",
      buttonText: "Review my essay"
    },
    {
      title: "Need help with your essays?",
      subtitle: "Our experts have reviewed thousands of essays and are available now!",
      buttonText: "Submit for review"
    }
  ];

  const selectedCopy = copyVariants[2];

  return (
    <div className="card rounded-1 border-0 shadow bg-yellow-50">
      <div className="card-body p-3 d-flex flex-column align-items-stretch">
        <div className="text-center fs-lg fw-semibold text-dark">{selectedCopy.title}</div>
        <div className="text-center mt-1">{selectedCopy.subtitle}</div>
        <div className="d-flex justify-content-center mt-3">
          <div className="avatar avatar-xl z-5">
            <img className="avatar-img rounded-circle" src='/img/advisors/veronica.png' />
          </div>
          <div className="avatar avatar-xl ms-n3 z-4">
            <img className="avatar-img rounded-circle" src='/img/advisors/elias.png' />
          </div>
          <div className="avatar avatar-xl ms-n3 z-3">
            <img className="avatar-img rounded-circle" src='/img/advisors/priya.png' />
          </div>
          <div className="avatar avatar-xl ms-n3 z-2">
            <img className="avatar-img rounded-circle" src='/img/advisors/daniel.png' />
          </div>
          <div className="avatar avatar-xl ms-n3 z-1">
            <img className="avatar-img rounded-circle" src='/img/advisors/amy.png' />
          </div>
        </div>
        <div className="mt-4 text-center">
          <a className="btn btn-primary w-100 fw-bold fs-lg mb-1" href={consultantsEssayReviewPath}>{selectedCopy.buttonText}</a>
        </div>
      </div>
    </div>
  )
}

